module.exports = __webpack_public_path__ + "static/media/material-ui.93d759d1.svg";